import type { Entity } from '@models/Entity'

import { request } from '../../../gateways/api'
import type { AssignedBijlage } from '../types/AssignedBijlage'

export { patchAssignedBijlageForEntity }

const patchAssignedBijlageForEntity = async ({
  entity: { id: entityId, type },
  id,
  dueWeek,
  status,
}: {
  entity: Entity
  id: string
  dueWeek?: string
  status?: string
}): Promise<AssignedBijlage> => {
  const body: { dueWeek?: string | null; status?: string } = {}

  // Allow null to remove dueWeek
  body.dueWeek = dueWeek || null

  if (status) body.status = status

  const { data } = await request({
    url: `/rest/${type}/${entityId}/bijlageassigned/${id}`,
    method: 'PATCH',
    data: body,
  })

  return data
}
